"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var DecisionButton_1 = __importDefault(require("./DecisionButton"));
function DecisionBar(_a) {
    var loading = _a.loading, items = _a.items, isInModerationMode = _a.isInModerationMode, toggleAllCheckboxes = _a.toggleAllCheckboxes, decisionText = _a.decisionText, isSubmittingLoading = _a.isSubmittingLoading, submitDecisions = _a.submitDecisions, refusalReasons = _a.refusalReasons, onSelectDecision = _a.onSelectDecision, selectedDecision = _a.selectedDecision, selectedJobRows = _a.selectedJobRows, total = _a.total;
    var t = (0, react_i18next_1.useTranslation)().t;
    var submitButtonRef = (0, react_1.useRef)(null);
    var numberOfJobsSelected = selectedJobRows.length;
    var isSubmittable = selectedDecision && selectedDecision.type !== null && numberOfJobsSelected;
    var isDecisionButtonDisabled = !isSubmittable || loading || isSubmittingLoading;
    var isAllItemChecked = numberOfJobsSelected === items.length;
    var renderNbItemSelectedTranslation = function () {
        if (numberOfJobsSelected === 0 || numberOfJobsSelected === 1)
            return react_1.default.createElement(react_i18next_1.Trans, { i18nKey: "SEARCH.HEADER.ITEMS_SELECTED_REACT_ONE_OR_ZERO_ITEM", count: numberOfJobsSelected });
        return react_1.default.createElement(react_i18next_1.Trans, { i18nKey: "SEARCH.HEADER.ITEMS_SELECTED_REACT_MANY_ITEMS", count: numberOfJobsSelected });
    };
    var handleSelectDecision = function (decision, decisionText) {
        var _a;
        // scroll to the top of the page
        window.scrollTo(0, 0);
        onSelectDecision(decision, decisionText);
        (_a = submitButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus(); // Focus the submit button
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, total > 0 && (react_1.default.createElement("div", { id: "eva-search-decision-bar-container" },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('eva-search-decision-bar', {
                'in-moderation-mode': isInModerationMode,
            }) }, isInModerationMode && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "eva-search-decision-bar-left" },
                react_1.default.createElement("label", { className: (0, clsx_1.default)('eva-search-decision-bar-checkbox', {
                        'some-selected': numberOfJobsSelected < (items === null || items === void 0 ? void 0 : items.length) && numberOfJobsSelected > 0,
                    }) },
                    react_1.default.createElement("input", { type: "checkbox", onChange: function (e) { return toggleAllCheckboxes(e.target.checked); }, checked: isAllItemChecked, id: "eva-search-general-checkbox" }),
                    react_1.default.createElement("i", { className: "eva-search-decision-bar-checkbox-icon" })),
                react_1.default.createElement("div", { className: (0, clsx_1.default)('eva-search-decision-bar-text-container', {
                        'has-decision': decisionText,
                    }) },
                    react_1.default.createElement("span", { className: "eva-search-decision-bar-text--item-selected" }, renderNbItemSelectedTranslation()),
                    react_1.default.createElement("span", { className: "eva-search-decision-bar-text--decision", title: decisionText }, decisionText))),
            react_1.default.createElement("div", { className: "eva-search-decision-bar-right" },
                react_1.default.createElement(DecisionButton_1.default, { refusalReasons: refusalReasons, onSelectDecision: handleSelectDecision, isSearchPage: true, selectedDecision: selectedDecision, isDisabled: false, enableKeyboardShortcuts: true }),
                react_1.default.createElement("button", { ref: submitButtonRef, className: (0, clsx_1.default)('eva-search-submit-decision-button submit-button', {
                        disabled: isDecisionButtonDisabled,
                    }), onClick: function () {
                        var _a;
                        !isDecisionButtonDisabled && submitDecisions();
                        (_a = submitButtonRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                    }, title: isSubmittable
                        ? t('SEARCH.HEADER.SUBMIT_BUTTON_TOOLTIP_SUBMITTABLE_REACT')
                        : t('SEARCH.HEADER.SUBMIT_BUTTON_TOOLTIP_NOT_SUBMITTABLE_REACT'), type: "button" },
                    react_1.default.createElement("i", { className: "implioicons-paper-plane" }))))))))));
}
exports.default = DecisionBar;
